import Dialog from '@mui/material/Dialog'

export const LoaderDialog = ({ open }) => {
    return (
        <>
            <Dialog
                PaperProps={{
                    style: {
                        background: '#000',
                        margin: 0,
                    },
                }}
                sx={{ opacity: 0.5 }}
                fullScreen
                open={open}>
                <img
                    src="/vector/logo-animation.svg"
                    style={{
                        width: '100%',
                        height: '100%',
                    }}
                />
            </Dialog>
        </>
    )
}
